/** Inline 7-day sparkline. `points` = array of 7 numbers, oldest -> newest. */
export default function Sparkline({ points, width = 96, height = 24, stroke = "#1D4ED8" }) {
  const max = Math.max(1, ...points);
  const stepX = points.length > 1 ? width / (points.length - 1) : width;
  const coords = points.map((v, i) => [i * stepX, height - (v / max) * (height - 4) - 2]);
  const path = coords.map(([x, y], i) => `${i === 0 ? "M" : "L"}${x.toFixed(1)},${y.toFixed(1)}`).join(" ");
  const areaPath = `${path} L${width},${height} L0,${height} Z`;
  const lastX = coords[coords.length - 1][0];
  const lastY = coords[coords.length - 1][1];
  return (
    <svg width={width} height={height} className="block" aria-hidden="true">
      <path d={areaPath} fill={stroke} opacity="0.10" />
      <path d={path} fill="none" stroke={stroke} strokeWidth="1.5" strokeLinejoin="round" strokeLinecap="round" />
      <circle cx={lastX} cy={lastY} r="2" fill={stroke} />
    </svg>
  );
}
